/**
 * InteractionContactCell - Displays contact information with fallback handling
 *
 * Specialized cell component for displaying interaction contacts in table/grid views.
 * Handles loading states and secondary targets.
 */

import { Link } from '@evertrue/et-components';
import PropTypes from 'prop-types';

/**
 * Displays contact information with fallback handling for loading states
 * @param {Object} interaction - Interaction object with contact information
 */
const InteractionContactCell = ({ interaction = {} }) => {
  const { contact = null, contact_id, secondary_target } = interaction;

  // If contact data is not available yet, show contact ID as fallback with loading indicator
  if (!contact) {
    return (
      <div>
        <span className="interaction-meta--header-name">
          <span className="fs-exclude-data text-muted">{contact_id ? `Contact ID: ${contact_id}` : 'Loading...'}</span>
        </span>
      </div>
    );
  }

  return (
    <div>
      {contact.name && (
        <>
          <span className="interaction-meta--header-name">
            <Link className="fs-exclude-data" href={`/contact/${contact_id}`} title={`profile of ${contact.name}`}>
              {contact.name}
            </Link>
          </span>
          {secondary_target && secondary_target.length > 0 && (
            <span className="interaction-meta--secondary-target"> + {secondary_target.length} more</span>
          )}
        </>
      )}
    </div>
  );
};

InteractionContactCell.propTypes = {
  interaction: PropTypes.object,
};

export default InteractionContactCell;
